var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Empty"},[_c('i',{staticClass:"el-icon-folder-opened"}),_c('span',[_vm._v(_vm._s((_vm.text && _vm.text.length>0)?_vm.text:'暂无数据'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }